import { AbstractControl } from '@angular/forms';

export function getFormControlError(control: AbstractControl | null): string {
  if (control?.errors) {
    if (control.errors['required']) {
      return 'This field cannot be blank';
    }
    if (control.errors['minlength']) {
      const minLength = control.errors['minlength'].requiredLength;
      return `This field must be at least ${minLength} characters long.`;
    }
    if (control.errors['min']) {
      const min = control.errors['min'].min;
      return `Minimum value should be ${min}.`;
    }
    if (control.errors['email']) {
      return `Invalid email format.`;
    }
    if (control.errors['pattern']) {
      return `Numbers only`;
    }
  }
  return '';
}
